import { Component, EventEmitter, OnInit, Output, ViewChild, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { Grid as InavistaGrid, GridActionIconClickEvent, GridConfig } from '@inavista/components/grid';
import { RemoteSearchGridApi, provideRemoteSearchGrid, remoteSearchRow } from '../../utils/remote-search-grid-api';
import { environment } from 'projects/service/src/environments/environment';
import {
  PROCEED_ACTION, PROCEED_ACTION_ICONS, RESOURCE_SELECTION_COLUMNS, RESOURCE_SELECTION_URL, buildResourceSelectionGridConfig,
} from './resource-selection.grid.config';

const BASE_URL = environment.apiUrl;
// The old grid's content was window.innerHeight - 350 tall, with its toolbar and header above it and the
// "Total Records" bar below. The inavista grid draws all of that inside its own box.
const GRID_CHROME_PX = 124;

@Component({
    selector: 'app-resource-selection-popup',
    templateUrl: './resource-selection-popup.component.html',
    styles: [],
    // The grid reads the old endpoint through RemoteSearchGridApi (same request, same response).
    providers: [...provideRemoteSearchGrid()],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResourceSelectionPopupComponent implements OnInit {

  isExpanded: boolean = false;
  gridConfig: GridConfig = null;
  readonly actionIcons = PROCEED_ACTION_ICONS;
  gridHeight: number = window.innerHeight - 350 + GRID_CHROME_PX;

  @ViewChild('resourceGrid') resourceGrid: InavistaGrid;

  @Input() responder: string;

  @Output() onClose = new EventEmitter();
  private readonly gridApi = inject(RemoteSearchGridApi);

  ngOnInit(): void {
    // POST pickers-scope/employee-search (ServiceEmployee/GetEmployeeSearchView's request and answer, on the person's tech
    // scope) with no parameters, as before (the old employeeId filter was commented out).
    this.gridApi.set(RESOURCE_SELECTION_URL, {
      endpoint: `${BASE_URL}pickers-scope/employee-search`,
      columns: RESOURCE_SELECTION_COLUMNS,
      searchFields: RESOURCE_SELECTION_COLUMNS.map(([c]) => c),
      parameters: [],
    });
    this.gridConfig = buildResourceSelectionGridConfig();
  }

  close() {
    this.onClose.emit();
  }

  onActionIconClick(event: GridActionIconClickEvent) {
    if (event.iconKey === PROCEED_ACTION) {
      const rowData: any = remoteSearchRow(event.row);
      rowData.technicianId = rowData.employeeId;
      rowData.technicianName = rowData.employeeName;
      this.onClose.emit(rowData);
    }
  }

}
